export default __webpack_public_path__ + "img/4f8c3e437661e69450398d855670c24e.mp4";